
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.47 16.47a.75.75 0 111.06 1.06L13.06 20l2.47 2.47a.75.75 0 11-1.06 1.06L12 21.06l-2.47 2.47a.75.75 0 01-1.06-1.06L10.94 20l-2.47-2.47a.75.75 0 111.06-1.06L12 18.94l2.47-2.47z","fill":"#F15757"}}),_c('path',{attrs:{"d":"M12.898 5.702a5.63 5.63 0 015.627 5.451 3.573 3.573 0 01-.097 7.145h-.36a6.243 6.243 0 00-.372-1h.732a2.574 2.574 0 00.07-5.145l-.943-.025-.03-.943a4.631 4.631 0 00-4.394-4.477l-.233-.006A4.633 4.633 0 008.5 9.88l-.227.686H6.365a3.364 3.364 0 00-.062 6.73 6.258 6.258 0 00-.368.98 4.366 4.366 0 01.43-8.71H7.55a5.633 5.633 0 015.348-3.864z","fill":"currentColor"}})])
          )
        }
      }
    